/**
 * @file: description
 * @author:
 * @Date: 2020-03-02 21:57:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-20 14:27:25
 */
import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  BannerVO,
  ParamsbannerDeleteTypeUsingDelete,
  ParamsbannerAddTypeUsingPost,
  ParamsBodybannerAddTypeUsingPost,
  ParamsbannerEditTypeUsingPost,
  ParamsBodybannerEditTypeUsingPost,
  ParamshomeBannerUsingGet,
  CommonResult
} from '@src/services';
import { message } from 'antd';

export interface State {
  bannerList: BannerVO[];
  loading: boolean;
}

export const bannerModelState: State = {
  bannerList: [],
  loading: false
};

const model = CM({
  state: bannerModelState,
  namespace: 'bannerModel',
  reducers: {
    /** 获取全部banner列表 */
    setBannerList: (state, action: Tction<{ bannerList: BannerVO[] }>) => {
      const { bannerList } = action.payload;
      return {
        ...state,
        bannerList
      };
    },
    updateLoading: (state, action: Tction<{ loading: boolean }>) => {
      const { loading } = action.payload;
      return {
        ...state,
        loading
      };
    },
    /** 更新banner */
    updateBannerList: (state, action: Tction<{ data: BannerVO }>) => {
      const { data } = action.payload;
      return {
        ...state,
        bannerList: state.bannerList.map(item => {
          if (item.id === data.id) {
            return data;
          }
          return item;
        })
      };
    }
  },
  effects: {
    /** 获取banner列表 */
    *getBannerList(
      { tPut, tCall },
      action: Tction<{
        params: ParamshomeBannerUsingGet;
        needLoading?: boolean;
        callBack?: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, needLoading = true, callBack } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, { loading: true });
      }

      const res: Utils.GetROA<typeof APIS.HomeApi.homeBannerUsingGet> = yield tCall(
        APIS.HomeApi.homeBannerUsingGet,
        params
      );
      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setBannerList, { bannerList: result || [] });
        callBack && callBack(res);
      } else {
        message.error(res.message);
      }
      if (needLoading) {
        yield tPut(model.actions.updateLoading, { loading: false });
      }
    },
    /** 添加 */
    *addBanner(
      { tPut, tCall },
      action: Tction<{
        params: ParamsbannerAddTypeUsingPost;
        data: ParamsBodybannerAddTypeUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const { params, data } = action.payload;
      const res: Utils.GetROA<typeof APIS.BannerApi.bannerAddTypeUsingPost> = yield tCall(
        APIS.BannerApi.bannerAddTypeUsingPost,
        params,
        data
      );
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.getBannerList, {
          params: { type: params.type },
          needLoading: false
        });
      } else {
        message.error(res.message);
      }
    },
    /** 删除 */
    *deleteBanner(
      { tPut, tCall },
      action: Tction<{ params: ParamsbannerDeleteTypeUsingDelete }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.BannerApi.bannerDeleteTypeUsingDelete> = yield tCall(
        APIS.BannerApi.bannerDeleteTypeUsingDelete,
        params
      );
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.getBannerList, {
          params: { type: params.type },
          needLoading: false
        });
      } else {
        message.error(res.message);
      }
    },
    /** 编辑 */
    *editBanner(
      { tPut, tCall },
      action: Tction<{
        params: ParamsbannerEditTypeUsingPost;
        data: ParamsBodybannerEditTypeUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const { params, data } = action.payload;
      const { type } = params;
      const res: Utils.GetROA<typeof APIS.BannerApi.bannerEditTypeUsingPost> = yield tCall(
        APIS.BannerApi.bannerEditTypeUsingPost,
        params,
        data
      );
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateBannerList, { data });
      } else {
        message.error(res.message);
      }
    }
  }
});

/**
 * @description 全局Model bannerModel 挂载到 redux 上
 */
export default model;
